module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-4-e03a007b.jpg";